let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2p07R")).then(() => parcelRequire('greUY'));